import { get, createBaseCRUDApi } from '@/api/base'
import { createBaseResponseErrors } from '@/utils/errors/baseResponseErrors'
import { LOGISTIC_URL } from './const'
import { ResponseError } from '@/classes/ResponseError'

export const LOGISTIC_WAYBILL_URL = `${LOGISTIC_URL}-waybill`
const LOGISTIC_WAYBILL_RESPONSIBLE_URL = LOGISTIC_WAYBILL_URL + '/responsible/list'

const errors = createBaseResponseErrors('путевой лист', 'путевых листов')

export const LogisticWaybillApi = {
  ...createBaseCRUDApi(LOGISTIC_WAYBILL_URL, errors),

  getResponsible: async (params) => {
    try {
      return await get(LOGISTIC_WAYBILL_RESPONSIBLE_URL, params)
    } catch (e) {
      throw new ResponseError(e, 'Не удалось получить список ответственных')
    }
  }
}
